import { createLocaleMessages } from "./createLocaleMessages";

export const GERMAN_TRANSLATIONS = createLocaleMessages({
  common: {
    appName: "Screen0",
    loading: "Laden…",
    loadingSettings: "Einstellungen werden geladen",
    loadingInsight: "Insight wird geladen…",
    close: "Schließen",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    done: "Fertig",
    send: "Senden",
    add: "Hinzufügen",
    create: "Erstellen",
    edit: "Bearbeiten",
    available: "Verfügbar",
    unavailable: "Nicht verfügbar",
    checking: "wird geprüft",
    somethingWentWrong: "Etwas ist schiefgelaufen",
    today: "Heute",
    thisWeek: "Diese Woche",
    thisMonth: "Dieser Monat",
    backToToday: "Zurück zu Heute",
    openSettings: "Einstellungen öffnen",
    primaryNavLabel: "Hauptnavigation",
    noUsage: "Keine Nutzung",
    emDash: "—",
    thinking: "Denke nach...",
    opening: "Wird geöffnet…",
    ok: "OK",
    dismiss: "Verwerfen",
    unknown: "Unbekannt",
  },
  navigation: {
    today: "Heute",
    habits: "Gewohnheiten",
    insight: "Insight",
    rules: "Regeln",
    settings: "Einstellungen",
    premiumLocked: "Premium",
  },
  today: {
    titleToday: "Heute",
    titleThisWeek: "Diese Woche",
    titleThisMonth: "Dieser Monat",
    periodDay: "Tag",
    periodWeek: "Woche",
    periodMonth: "Monat",
    periodLabel: "Zeitraum",
    viewApps: "Apps",
    viewCategories: "Kategorien",
    metricScreenTime: "Bildschirmzeit",
    metricScreenTimeAndroid: "Nutzungszeit",
    metricActivations: "Aktivierungen",
    viewToggleAria: "Ansicht: {view}. Tippen zum Wechseln.",
    metricToggleAria: "Metrik: {metric}. Tippen zum Wechseln.",
    periodToggleAria: "Zeitraum: {period}. Tippen zum Wechseln.",
    prevNavAria: "Vorheriger {period}",
    nextNavAria: "Nächster {period}",
    navDay: "Tag",
    navWeek: "Woche",
    navMonth: "Monat",
    noSnapshotDayTitle: "Kein Snapshot für diesen Tag",
    noSnapshotWeekTitle: "Keine Snapshots für diese Woche",
    noSnapshotMonthTitle: "Keine Snapshots für diesen Monat",
    noSnapshotDayBody:
      "Für diesen Tag wurde kein Snapshot gespeichert. Probiere ein anderes Datum oder kehre zu heute zurück.",
    noSnapshotWeekBody:
      "Diese Woche hat noch nicht genug gespeicherte Snapshots. Probiere eine frühere Woche oder schau nach weiteren täglichen Erfassungen wieder vorbei.",
    noSnapshotMonthBody:
      "Dieser Monat hat noch nicht genug gespeicherte Snapshots. Probiere einen früheren Monat oder schau nach weiteren täglichen Erfassungen wieder vorbei.",
    preInstallDayTitle: "Keine Daten für diesen Tag",
    preInstallDayBody:
      "Nutzungsdaten sind nur ab der ersten Installation von Screen0 auf diesem Gerät verfügbar. Frühere Daten sind nicht verfügbar.",
    preInstallWeekTitle: "Keine Daten für diese Woche",
    preInstallWeekBody:
      "Diese ganze Woche liegt vor der Installation von Screen0 auf diesem Gerät, daher sind keine Nutzungsdaten verfügbar.",
    preInstallMonthTitle: "Keine Daten für diesen Monat",
    preInstallMonthBody:
      "Dieser ganze Monat liegt vor der Installation von Screen0 auf diesem Gerät, daher sind keine Nutzungsdaten verfügbar.",
    noUsageRecorded: "Noch keine Nutzung erfasst",
    permissionNeededTitle: "Berechtigung für den heutigen Bericht erforderlich",
    permissionNeededBody:
      "Screen0 funktioniert ohne Konto, aber iOS erfordert die Bildschirmzeit-Berechtigung, bevor App-Nutzung angezeigt werden kann.",
    permissionDeniedHint:
      "Öffne Einstellungen und tippe auf Bildschirmzeit-Zugriff anfordern, dann bestätige Apples Dialog „App- und Website-Nutzung“, um den heutigen Bericht freizuschalten.",
    reasonIosDataExportRequires264:
      "Apple erlaubt Apps das Lesen von Bildschirmzeit-Daten erst ab iOS 26.4. Aktualisiere iOS, um die Nutzung hier zu sehen.",
    reasonDataExportUnavailable:
      "Apple erlaubt den Export von Bildschirmzeit-Daten derzeit nur auf Geräten in der EU, daher kann auf diesem Gerät keine Nutzung gelesen werden.",
    reasonExtensionSnapshotMissing:
      "Die Berichtserweiterung wurde gestartet, aber der App-Gruppen-Snapshot war in diesem Durchlauf nicht lesbar.",
    reasonReportViewNotMounted:
      "Screen0 konnte den nativen Geräteaktivitäts-Bericht-Host nicht laden.",
    reasonDefaultNoData:
      "Nutze dein Telefon ein paar Minuten, wechsle dann zurück zu Heute oder öffne Screen0 erneut. iOS kann auch am Tagesanfang keine Daten liefern.",
    permissionNeededBodyAndroidRestricted:
      "Android hat diese Berechtigung blockiert, weil Screen0 außerhalb eines App-Stores installiert wurde. Tippe zuerst unten auf „Screen0-App-Info öffnen“, öffne das ⋮-Menü oben rechts und wähle „Eingeschränkte Einstellungen zulassen“ (mit PIN bestätigen). Kehre dann zurück und aktiviere den Zugriff auf Nutzungsdaten.",
    openAppInfo: "Screen0-App-Info öffnen",
    reasonDefaultNoDataAndroid:
      "Der Zugriff auf Nutzungsdaten ist aktiv. Nutze das Gerät ein paar Minuten, kehre dann zu Heute zurück oder öffne Screen0 erneut — Android kann für die ersten Daten etwas brauchen.",
    collectingUsageTitle: "Nutzungsdaten werden gelesen…",
    collectingUsageBody:
      "Der Zugriff auf Nutzungsdaten ist aktiv. Screen0 liest gerade die heutige Nutzung — das dauert nur einen Moment.",
    collectingUsageBodyAndroid:
      "Der Zugriff auf Nutzungsdaten ist aktiv. Screen0 liest die heutige Nutzung von Android — direkt nach der Freigabe kann das ein paar Sekunden dauern.",
    reasonUsageEventsUnavailableAndroid:
      "Der Zugriff auf Nutzungsdaten scheint aktiv, aber Android teilt noch keine Daten mit Screen0. Öffne die Einstellungen, schalte den Zugriff für Screen0 aus und wieder ein und öffne die App erneut. Bei Installationen außerhalb eines App-Stores wähle zuerst „Eingeschränkte Einstellungen zulassen“ in der App-Info (⋮-Menü).",
    reasonAppsNotVisibleAndroid:
      "Android hat Nutzung erfasst, aber Screen0 konnte die Apps nicht identifizieren. Aktualisiere oder installiere Screen0 neu und versuche es erneut.",
    weeklyActivationsNotTracked: "Wöchentliche Aktivierungen werden noch nicht erfasst",
    monthlyActivationsNotTracked: "Monatliche Aktivierungen werden noch nicht erfasst",
    activationsNotTracked: "Aktivierungen noch nicht erfasst",
    topApps: "Top-Apps",
    allApps: "Alle Apps",
    topCategories: "Top-Kategorien",
    allCategories: "Alle Kategorien",
    topActivations: "Top-Aktivierungen",
    allActivations: "Alle Aktivierungen",
    topCategoryActivations: "Top-Kategorie-Aktivierungen",
    allCategoryActivations: "Alle Kategorie-Aktivierungen",
    viewAllAppsAria: "Alle Apps anzeigen",
    viewAllCategoriesAria: "Alle Kategorien anzeigen",
    viewAllActivationsAria: "Alle Aktivierungen anzeigen",
    viewAllCategoryActivationsAria: "Alle Kategorie-Aktivierungen anzeigen",
    dayShape: "Tagesverlauf",
    weekShape: "Wochenverlauf",
    monthShape: "Monatsverlauf",
    dailyAverage: "Ø/Tag",
    dailyAverageOn: "an",
    dailyAverageOff: "aus",
    dailyAverageToggleAria: "Tagesdurchschnitt {state}. Tippen zum Umschalten.",
  },
  habits: {
    title: "Gewohnheiten",
    timeframe: "Letzte 12 Monate",
    reorder: "Apps neu anordnen",
    doneReordering: "Neuordnung abgeschlossen",
    openFilter: "Gewohnheiten-Filter öffnen",
    metricToggleAria: "Metrik: {metric}. Tippen zum Wechseln.",
    emptyTitle: "Noch keine App-Nutzungsdaten",
    emptyBody:
      "Erlaube Bildschirmzeit-Zugriff über Heute, um Gewohnheiten zu verfolgen.",
    emptyBodyAndroid:
      "Erlaube den Zugriff auf Nutzungsdaten über Heute, um Gewohnheiten zu verfolgen.",
    filterView: "Ansicht",
    filterTrackApps: "Apps verfolgen",
    filterTrackCategories: "Kategorien verfolgen",
    filterCategories: "Kategorien",
    filterShowingAll: "Alles anzeigen. Auswählen, um nur bestimmte zu verfolgen.",
    filterTrackingSelected: "{count} Ausgewählte werden verfolgt.",
    filterSearchPlaceholder: "Apps suchen, die du genutzt hast",
    filterSearchAria: "Apps suchen",
    closeFilter: "Filter schließen",
    previousMonth: "Vorheriger Monat",
    nextMonth: "Nächster Monat",
    filterOtherSection: "Sonstiges-Bucket",
    includeOther: "Sonstiges einbeziehen",
    includeOtherAria: "Sonstiges-Bucket in Gewohnheiten einbeziehen",
    includeOtherInfoAria: "Was ist der Sonstiges-Bucket?",
    otherInfoTitle: "Was ist Sonstiges?",
    otherInfoBody:
      "Sonstiges ist Bildschirmzeit, die iOS keiner bestimmten App zuordnen konnte. Häufig stammt sie von deinstallierten Apps, Systemnutzung oder kleinen Lücken zwischen deiner gesamten Bildschirmzeit und der Summe der einzelnen Apps.",
    otherInfoBodyAndroid:
      "Sonstiges ist Nutzungszeit, die Android keiner bestimmten App zuordnen konnte. Häufig stammt sie von deinstallierten Apps, Systemnutzung oder kleinen Lücken zwischen deiner gesamten Nutzung und der Summe der einzelnen Apps.",
  },
  insight: {
    title: "Insight",
    timeframe: "Letzte {days} Tage",
    compulsivity: "Zwanghaftigkeit",
    doomScrollRisk: "Doom-scroll",
    aboutMetricAria: "Über {metric}",
    compulsivityBody1:
      "Wie oft du dieselben Apps im Verhältnis zu allem anderen auf deinem Telefon wieder öffnest. Hohe Werte bedeuten meist häufiges Entsperren und wiederholte Besuche, nicht nur lange Sitzungen.",
    compulsivityBody2:
      "Screen0 kombiniert, wie oft eine App geöffnet wird, wie viel Gesamtzeit sie beansprucht und an wie vielen Tagen sie in deinen recenten Snapshots vorkommt.",
    compulsivityBody3:
      "Das sind Proxy-Schätzungen der letzten 14 Tage — nützliche Muster, keine klinische Messung.",
    doomBody1:
      "Apps, deren Nutzung sich wiederholt und in wenige Stunden des Tages clustert — das Muster, das in gedankenloses Scrollen übergehen kann, jederzeit.",
    doomBody2:
      "Screen0 gewichtet, wie viel Zeit eine App beansprucht, wie konstant sie erscheint und wie konzentriert diese Nutzung über den Tag in deinen recenten Snapshots ist.",
    doomBody3:
      "Die Werte sind Proxy-Schätzungen der letzten 14 Tage und spiegeln Gewohnheiten wider, nicht Absichten.",
    activateSmartBlockAria: "Smart Block für {appName} aktivieren",
    reactivateSmartBlockAria: "Smart Block für {appName} reaktivieren",
    activeSmartBlocksTitle: "Aktive Smart Blocks",
    activeSmartBlocksAria: "Aktive Smart-Block-Regeln auf diesem Gerät",
    goToActiveSmartBlockRuleAria: "Zur Regel für {appName} wechseln",
    activateSmartBlockTitle: "Diesen Smart Block aktivieren?",
    reactivateSmartBlockTitle: "Diesen Smart Block reaktivieren?",
    activateConfirmBody:
      "Erstellt eine aktive Regel, die {appName} jeden Tag {window} aussetzt.",
    reactivateConfirmBody:
      "Schaltet deine bestehende Regel für {appName} jeden Tag {window} wieder ein.",
    activate: "Aktivieren",
    reactivate: "Reaktivieren",
    notFoundTitle: "Insight nicht gefunden",
    notFoundBody: "Dieser Insight wurde möglicherweise gelöscht oder noch nicht erzeugt.",
    statusPermissionNeededBodyAndroid:
      "Erlaube den Zugriff auf Nutzungsdaten über Heute, bevor Insight aktuelle App-Muster bewerten kann.",
    openExclude: "Von Insight ausgeschlossene Apps verwalten",
    excludeSheetTitle: "Von Insight ausschließen",
    closeExclude: "Ausschlüsse schließen",
    excludeSectionLabel: "Ausgeschlossene Apps",
    excludeHelperAllIncluded:
      "Alle Apps fließen in Insight-Werte ein. Markiere Apps, um sie von Zwanghaftigkeit, Doom-scroll und Smart-Block-Vorschlägen auszuschließen.",
    excludeHelperCount: "{count} Apps von Insight-Werten ausgeschlossen.",
    excludeSearchPlaceholder: "Apps suchen, die du genutzt hast",
    excludeSearchAria: "Apps suchen",
    excludeSearchResults: "Suchergebnisse",
    excludeSearching: "Suche…",
    excludeNoMatchingApps: "Keine passenden Apps",
    excludeNoApps: "Noch keine Apps in diesem Zeitraum",
    excludeIncludeAll: "Alle einbeziehen",
    smartBlockPrePickerTitle: "Apps in Bildschirmzeit auswählen",
    smartBlockPrePickerReactivateTitle: "Apps in Bildschirmzeit erneut auswählen",
    smartBlockPrePickerBody:
      "Als Nächstes erscheint Apples App-Auswahl. Wähle {appName}, damit Screen0 die App in diesem Smart-Block-Fenster sperren kann.",
    smartBlockPrePickerReactivateBody:
      "Als Nächstes erscheint Apples App-Auswahl. Wähle {appName} erneut, damit Screen0 diesen Smart Block durchsetzen kann.",
    smartBlockPrePickerNext: "Weiter",
    smartBlockPickerTitle: "{appName} wählen",
    smartBlockPickerHeader: "{appName} wählen",
    smartBlockPickerFooter:
      "Wähle die von deinem Smart Block vorgeschlagene App. Screen0 kann deine Auswahl nicht prüfen — wähle sorgfältig.",
    smartBlockHonorTitle: "Hast du {appName} gewählt?",
    smartBlockHonorBody:
      "Auf dem vorherigen Bildschirm solltest du die App auswählen, die dieser Smart Block betrifft.",
    smartBlockHonorYes: "Ja, fortfahren",
    smartBlockHonorNo: "Nein",
    smartBlockDeclinedTitle: "Smart Block braucht {appName}",
    smartBlockDeclinedBody:
      "Dieser Smart Block kann nur erstellt werden, wenn du {appName} in Apples Auswahl wählst.",
    smartBlockRetryPicker: "Erneut versuchen",
    smartBlockNonConformingTitle: "Auswahl passt nicht zum Smart Block",
    smartBlockNonConformingBody:
      "Du hast {appCount} Apps, {categoryCount} Kategorien und {siteCount} Websites gewählt. Die Regel kann trotzdem erstellt werden, wird aber nicht als Smart Block markiert.",
    smartBlockNonConformingContinue: "Manuelle Regel erstellen",
  },
  rules: {
    title: "Regeln",
    reorder: "Neu anordnen",
    doneReordering: "Neuordnung abgeschlossen",
    dismiss: "Verwerfen",
    activeRulesTitle: "Geplante Regeln",
    activeRulesLoading: "Laden…",
    activeRulesEnforcing: "{count} werden gerade durchgesetzt",
    activeRulesEmptySchedule: "Aussetzung planen",
    noActiveRulesTitle: "Keine geplanten Regeln",
    noActiveRulesBody:
      "Wähle, was blockiert wird, wann und an welchen Tagen — die erste Regel dauert etwa eine Minute.",
    newRule: "Neue Regel",
    targetsTitle: "Ziele",
    targetsSaved: "{count} gespeichert",
    targetsEmptySubtitle: "Wiederverwendbare Block-Bündel für Apps und Websites",
    noTargetsTitle: "Noch keine Ziele",
    noTargetsBody:
      "Erstelle ein benanntes Bündel aus Apps, Websites oder Kategorien — und nutze es in Regeln und Schnellsitzungen.",
    newTarget: "Neues Ziel",
    addSectionAria: "{title} hinzufügen",
    deleteRuleAria: "Regel löschen",
    deleteTargetAria: "Ziel löschen",
    deleteRuleConfirmAria: "Diese Regel löschen?",
    deleteTargetConfirmAria: "Dieses Ziel löschen?",
    deleteRuleConfirm: "Diese Regel löschen?",
    deleteTargetConfirm: "Dieses Ziel löschen?",
    deleteRuleCoveredConfirm:
      "Diese Regel löschen? Dieselben Apps und Websites bleiben durch eine andere aktive Regel blockiert.",
    deleteTargetCoveredConfirm:
      "Dieses Ziel löschen? Dieselben Apps und Websites bleiben durch eine andere aktive Regel blockiert.",
    deleteRuleCoveredConfirmAria: "Diese Regel löschen, während die Blockierung bestehen bleibt?",
    deleteTargetCoveredConfirmAria: "Dieses Ziel löschen, während die Blockierung bestehen bleibt?",
    editRuleAria: "{name} bearbeiten",
    editTargetAria: "{targetName} bearbeiten",
    enableRuleAria: "Regel aktivieren",
    disableRuleAria: "Regel deaktivieren",
    noTargets: "Keine Ziele",
    ruleUpdated: "Regel aktualisiert.",
    ruleCreated: "Regel erstellt.",
    ruleSaveFailed: "Regel konnte nicht gespeichert werden. Versuche es erneut.",
    targetCreated: "Ziel erstellt.",
    targetUpdated: "Ziel aktualisiert.",
    targetSaveFailed: "Ziel konnte nicht gespeichert werden. Versuche es erneut.",
    ruleDeleted: "Regel gelöscht.",
    targetDeleted:
      "Ziel gelöscht. Regeln, die nur dieses Ziel nutzten, wurden entfernt.",
    editRule: "Regel bearbeiten",
    newRuleEditor: "Neue Regel",
    saveRule: "Regel speichern",
    createRule: "Regel erstellen",
    editTarget: "Ziel bearbeiten",
    newTargetEditor: "Neues Ziel",
    saveTarget: "Ziel speichern",
    createTarget: "Ziel erstellen",
    targetsSection: "Ziele",
    targetsLimitHint: "Bis zu {max} pro Regel",
    targetsLimitReached: "Du kannst bis zu {max} Ziele pro Regel wählen. Wähle eines ab, um ein anderes hinzuzufügen.",
    targetsRequired: "Wähle mindestens ein Ziel, um diese Regel zu speichern.",
    targetEditorFromRule: "Ziel für diese Regel hinzufügen",
    targetEditorFromQuickStart: "Ziel für Schnellstart hinzufügen",
    backToRule: "Zurück zur Regel",
    backToQuickStart: "Zurück zum Schnellstart",
    websiteCategoriesLink: "Website-Kategorien durchsuchen",
    websiteCategoriesHint: "Ganze Gruppen wie Social oder Nachrichten blockieren — ohne Domains einzutippen.",
    createTargetCta: "Erstes Ziel erstellen",
    createTargetHint: "Benenne ein Bündel aus Apps oder Websites und wähle es in Regeln.",
    daysSection: "Tage",
    timeWindowSection: "Zeitfenster",
    startLabel: "Start",
    endLabel: "Ende",
    endsLabel: "Endet",
    durationMode: "Dauer",
    endTimeMode: "Endzeit",
    blockDurationAria: "Blockierdauer in Minuten",
    targetNamePlaceholder: "z. B. Social, Ablenkungen bei der Arbeit",
    chooseAppsSites: "Apps und Websites zum Blockieren wählen",
    websitePlaceholder: "beispiel.de",
    websiteAria: "Website-Domain",
    tapToChangeBlocked: "Tippen, um Blockiertes zu ändern",
    chosenOnDevice: "Auf diesem iPhone gewählt",
    changeBlockedAppsAria: "Blockierte Apps ändern",
    viewFullBlockedListAria: "Vollständige Blockierliste anzeigen",
    view: "Anzeigen",
    smartBlockBadge: "Smart Block",
    smartBlockRuleWindowTitle: "Smart-Block-Zeit bearbeiten",
    smartBlockRuleWindowBody:
      "Du kannst nur ändern, wann dieser Smart Block aktiv ist. Apps, Tage und andere Einstellungen bleiben gesperrt.",
    smartBlockRuleWindowAria: "Smart-Block-Zeitfenster bearbeiten",
    smartBlockMinDurationError: "Smart Blocks müssen mindestens 1 Stunde lang sein.",
    smartBlockEndBeforeStartError: "Die Endzeit muss nach der Startzeit liegen.",
    smartBlockRuleNotEditable: "Eine Smart-Block-Regel kann nicht bearbeitet werden.",
    smartBlockTargetNotEditable: "Smart-Block-Ziele können nicht bearbeitet werden.",
    smartBlockRuleNotEditableAria: "Smart-Block-Regel nicht bearbeitbar",
    smartBlockTargetNotEditableAria: "Smart-Block-Ziel nicht bearbeitbar",
    enforcementBannerTitle: "Wird gerade angewendet",
    enforcementBannerEndsIn: "Endet in {time}",
    enforcementBannerMore: "+{count} weitere",
    enforcementBreakBannerTitle: "Pause aktiv",
    enforcementBreakBannerEndsIn: "Endet in {time}",
    quickStart: {
      fabLabel: "Starten",
      fabAria: "Schnelle Blocksitzung starten",
      drawerTitle: "Schnellstart",
      durationLabel: "Dauer",
      durationAria: "Dauer der Schnellsitzung in Minuten",
      recentTab: "Zuletzt",
      savedTab: "Gespeichert",
      savePrompt: "Dieser Sitzung einen Namen geben",
      savePromptTitle: "Zu Favoriten hinzufügen",
      savePromptHint: "Tippe auf den Stern bei einer letzten Sitzung, um sie mit einem Tipp wiederzuverwenden.",
      saveNamePlaceholder: "z. B. Fokusstunde",
      noRecents: "Keine letzten Sitzungen",
      noSaved: "Keine gespeicherten Sitzungen",
      createTarget: "Neues Ziel",
      changeIcon: "Symbol ändern",
      sessionActive: "Blockierung aktiv",
      saveStarAria: "Sitzung speichern",
      savedStarAria: "Sitzung gespeichert",
      defaultSessionName: "Sitzung",
      startButton: "Sitzung starten",
      noValidTargets: "Diese Ziele wurden entfernt. Wähle mindestens ein Ziel aus.",
    },
    swipeUnlock: {
      trackLabel: "Wischen, um die Blockierung zu stoppen",
      trackAria: "Ziehen, um alle Blockierungen zu stoppen",
      overlayTitle: "Zum Entsperren gedrückt halten",
      overlayBody: "Dies stoppt sofort jede aktive Regel und Sitzung. Halte gedrückt, um zu bestätigen, dass du wirklich entsperren willst.",
      holdAria: "Zum Bestätigen gedrückt halten",
      holdHint: "Weiter gedrückt halten…",
      takeBreak: "{minutes}-Minuten-Pause nehmen",
    },
    forcedSuspend: {
      badge: "Du pausiert",
      subtitle: "Tippe auf Power, um die Blockierung fortzusetzen.",
      autoResume: "Setzt fort {time}.",
      resumeRuleAria: "Blockierung für diese Regel fortsetzen",
    },
    vpnInstallPrompt: {
      title: "Website-Filter installieren",
      body: "Eine Regel blockiert gerade Websites. Installiere das VPN-Profil auf dem Gerät, damit diese Seiten in Safari blockiert bleiben.",
      bodyAndroid:
        "Eine Regel blockiert gerade Websites. Installiere das VPN-Profil auf dem Gerät, damit diese Seiten in Chrome und anderen Browsern blockiert bleiben.",
      install: "PROFIL INSTALLIEREN",
      installing: "WIRD INSTALLIERT…",
      notNow: "NICHT JETZT",
      dismissAria: "Hinweis zum Website-Filter schließen",
    },
    vpnWebTargetGate: {
      title: "Website-Filter erforderlich",
      body:
        "Website-Blockierung braucht das Filterprofil auf dem Gerät. Nur-App-Ziele funktionieren ohne — installiere das Profil, um Domains oder Kategorien hinzuzufügen.",
      banner:
        "Installiere den Website-Filter auf dem Gerät, um hier Domains oder Kategorien hinzuzufügen.",
      install: "PROFIL INSTALLIEREN",
      installing: "WIRD INSTALLIERT…",
      continueAppsOnly: "Nur Apps",
      dismissAria: "Hinweis zur Website-Filter-Pflicht schließen",
      saveBlocked: "Installiere den Website-Filter, um neue Domains oder Kategorien zu speichern.",
    },
  },
  chat: {
    title: "Screen0 fragen",
    engineIosLocal: "Lokale KI auf iOS",
    engineAndroidLocal: "Lokale KI auf Android",
    engineCloud: "Cloud-KI",
    closeChatAria: "Chat schließen",
    suggestionWhatChanged: "Was hat sich heute geändert?",
    suggestionWhichApp: "Welche App hat mich reingezogen?",
    suggestionTonight: "Was soll ich heute Abend probieren?",
    placeholder: "Frage zu deiner Nutzung stellen",
    sendAria: "Senden",
    unableToAnswer: "Antwort derzeit nicht möglich.",
    localAiUnavailableSuffix:
      "Lokale KI ist derzeit nicht verfügbar. Cloud-Chat wird auf diesem Gerät nicht automatisch genutzt.",
  },
  insightChat: {
    fabAria: "Frage zu deiner Handynutzung stellen",
    title: "Nutzungs-Chat",
    privacyBadge: "100 % auf dem Gerät",
    engineIosLocal: "Lokale KI auf iOS",
    engineAndroidLocal: "Lokale KI auf Android",
    greeting:
      "Was möchtest du über deine Handynutzung wissen? Ich kann Muster aus deinem aktuellen Insight-Fenster erklären.",
    suggestionTotalUsage: "Wie viel habe ich mein Handy genutzt?",
    suggestionTopApp: "Welche App nutze ich am meisten?",
    suggestionBusiestDays: "An welchen Tagen nutze ich mein Handy am meisten?",
    suggestionBusiestBands: "Welche Tageszeiten sind am intensivsten?",
    suggestionTopAppWhy: "Warum nutze ich {appName} so oft?",
    suggestionTopAppWhyGeneric: "Warum nutze ich meine meistgenutzte App so oft?",
    suggestionComparePeriods: "Vergleiche diesen Zeitraum mit dem vorherigen",
    placeholder: "Frage zu deinen Nutzungsmustern stellen",
    sendAria: "Nachricht senden",
    closeAria: "Nutzungs-Chat schließen",
    unableToAnswer: "Antwort derzeit nicht möglich.",
    contextLoading: "Nutzungskontext wird vorbereitet…",
    contextError: "Nutzungskontext konnte nicht geladen werden. Erneut versuchen oder Chat schließen und neu öffnen.",
    contextEmpty: "Noch nicht genug aktuelle Nutzungsdaten für den Chat.",
    retryContext: "Erneut versuchen",
  },
  settings: {
    title: "Einstellungen",
    controlsEyebrow: "Steuerung",
    screenTimeSection: "Bildschirmzeit",
    screenTimeSectionAndroid: "Zugriff auf Nutzungsdaten",
    permissionLabel: "Berechtigung",
    requestingAccess: "Zugriff wird angefordert",
    requestScreenTimeAccess: "Bildschirmzeit-Zugriff anfordern",
    legalSection: "Rechtliches",
    privacyPolicyRow: "Datenschutzerklärung",
    termsRow: "Nutzungsbedingungen",
    resetSection: "Zurücksetzen",
    deletingSavedData: "Gespeicherte Daten werden gelöscht",
    deleteSavedData: "Gespeicherte Daten löschen und Geräte-ID zurücksetzen",
    resetSuccess:
      "{count} gespeicherte Datensätze gelöscht. Eine neue anonyme Geräte-ID wurde erstellt.",
    resetFailed: "Zurücksetzen fehlgeschlagen.",
    footerNoAccount: "Kein Konto erforderlich.",
    languageRow: "Sprache",
    purchasesSection: "Käufe",
  },
  language: {
    eyebrow: "App-Sprache",
    title: "Sprachen",
    subtitle:
      "Screen0 folgt der bevorzugten App-Sprache aus den Systemeinstellungen. Ändere sie jederzeit in den iPhone-Einstellungen.",
    subtitleAndroid:
      "Screen0 folgt der bevorzugten App-Sprache aus den Systemeinstellungen. Ändere sie jederzeit in den Android-Einstellungen.",
    subtitleAndroidLegacy:
      "Auf dieser Android-Version folgt Screen0 der Gerätesprache. Ändere sie unter Einstellungen → Sprache und Eingabe.",
    activeLanguageLabel: "Aktive Sprache",
    systemLanguageLabel: "Systemeinstellung",
    fallbackNote:
      "Die gewählte Systemsprache wird von Screen0 noch nicht unterstützt, daher verwendet die App Englisch als Fallback.",
    unavailableSystemValue: "Nicht verfügbar",
    openSettingsTitle: "iPhone-Einstellungen öffnen",
    openSettingsTitleAndroid: "App-Spracheinstellungen öffnen",
    openSettingsTitleAndroidLegacy: "Android-Einstellungen öffnen",
    openSettingsSubtitle:
      "Gehe zur Screen0-Systemseite, um die App-Sprache zu ändern.",
    openSettingsSubtitleAndroid:
      "Gehe zur Screen0-Sprachseite, um die App-Sprache zu ändern.",
    openSettingsSubtitleAndroidLegacy:
      "Die App-Info öffnet sich hier. Ändere die Gerätesprache unter Sprachen — App-Sprache benötigt Android 13 oder neuer.",
    openingSettingsLabel: "Einstellungen werden geöffnet",
    closeLabel: "Schließen",
    footerReady:
      "Wenn du zur App zurückkehrst, synchronisiert Screen0 automatisch die aktualisierte Sprache.",
    footerReadyAndroid:
      "Wenn du zur App zurückkehrst, synchronisiert Screen0 automatisch die aktualisierte Sprache.",
    footerReadyAndroidLegacy:
      "Wenn du zur App zurückkehrst, synchronisiert Screen0 die aktuelle Gerätesprache.",
    footerOpening: "Systemseite wird geöffnet...",
    openSettingsUnavailableTitle: "Einstellungen nicht verfügbar",
    openSettingsUnavailableDescription:
      "Ich kann die App-Einstellungen in dieser Umgebung nicht öffnen.",
  },
  permission: {
    gateTitle: "Berechtigung für den heutigen Bericht erforderlich",
    gateBody:
      "Screen0 funktioniert ohne Konto, aber iOS erfordert die Bildschirmzeit-Berechtigung, bevor App-Nutzung angezeigt werden kann.",
    requestingAccess: "Zugriff wird angefordert",
    requestScreenTimeAccess: "Bildschirmzeit-Zugriff anfordern",
    entitlementMissing:
      "Dieser Build enthält nicht das Family-Controls-Entitlement oder das passende Provisioning-Profil. Bildschirmzeit-Daten können erst nach Korrektur der Signierung erfasst werden.",
  },
  calendar: {
    chooseDate: "Datum wählen",
    previousMonth: "Vorheriger Monat",
    nextMonth: "Nächster Monat",
  },
  query: {
    loadingDefault: "Laden…",
    errorTitle: "Etwas ist schiefgelaufen",
  },
  app: {
    syncError:
      "Die heutige Nutzung konnte nicht gespeichert werden. Screen0 versucht es erneut, wenn du die App wieder öffnest.",
    reinstallRulesPurged:
      "Deine Sperrregeln wurden zurückgesetzt, weil App-Auswahlen nach einer Neuinstallation nicht erhalten bleiben. Richte sie unter Regeln erneut ein.",
  },
  format: {
    activationSingular: "Aktivierung",
    activationPlural: "Aktivierungen",
    durationMinutes: "{minutes} Min.",
    durationHoursOnly: "{hours} Std.",
    durationOneHour: "1 Std.",
    durationHoursMinutes: "{hours} Std. {minutes} Min.",
    allDay: "Ganztägig",
    timeBandMorning: "Morgen",
    timeBandAfternoon: "Nachmittag",
    timeBandEvening: "Abend",
    timeBandNight: "Nacht",
  },
  appDetail: {
    dailyAverage: "Tagesdurchschnitt",
    dailyAverageInfoAria: "Über den Tagesdurchschnitt ({metric})",
    dailyAverageInfoBodyTime1:
      "Durchschnittliche stündliche Bildschirmzeit dieser App in den letzten ~12 Monaten.",
    dailyAverageInfoBodyTime2:
      "Jede Stunde ist der Mittelwert über alle Tage mit Gerätedaten in diesem Zeitraum. Tage ohne Nutzung dieser App zählen als null. Tage vor Beginn der Datenerfassung sind ausgeschlossen.",
    dailyAverageInfoBodyOpens1:
      "Durchschnittliche stündliche Aktivierungen dieser App in den letzten ~12 Monaten.",
    dailyAverageInfoBodyOpens2:
      "Jede Stunde ist der Mittelwert über alle Tage mit Gerätedaten in diesem Zeitraum. Tage ohne Nutzung dieser App zählen als null. Tage vor Beginn der Datenerfassung sind ausgeschlossen.",
    panelCalendar: "Kalender",
    panelChart: "Diagramm",
    noUsage: "Keine Nutzung",
  },
  ring: {
    screenTime: "Bildschirmzeit",
    activations: "Aktivierungen",
    percentOfTotal: "{percent} % der Gesamtnutzung",
    notTracked: "Nicht erfasst",
    screenActivationsByApp: "Bildschirmaktivierungen nach App",
    screenTimeByApp: "Bildschirmzeit nach App",
    showScreenTime: "Bildschirmzeit anzeigen",
    showScreenActivations: "Bildschirmaktivierungen anzeigen",
    chartDescriptionDay:
      "Stündliche Bildschirmzeit und Aktivierungen für den gewählten Tag",
    chartDescriptionWeek:
      "Tägliche Bildschirmzeit und Aktivierungen für die gewählte Woche",
    chartDescriptionMonth:
      "Tägliche Bildschirmzeit und Aktivierungen für den gewählten Monat",
  },
  smartBlock: {
    goalDoom: "Doom-Scroll reduzieren",
    goalCompulsivity: "Zwanghaftigkeit reduzieren",
    actionLabel: "{range} vollständig blockieren",
    reasonDoomShare:
      "{sharePct} % deiner {name}-Nutzung findet zwischen {range} statt. Das Blockieren dieses Fensters zielt auf deine risikoreichste Phase.",
    reasonDoomCluster:
      "Die Nutzung von {name} clustert tendenziell in diesem Tagesabschnitt. Das Blockieren von {range} zielt auf deine risikoreichste Phase.",
    reasonCompulsivityOpens: "Du öffnest {name} am häufigsten zwischen {range}.",
    reasonCompulsivityTime: "Der Großteil deiner {name}-Zeit liegt zwischen {range}.",
    reasonCompulsivityShareSuffix:
      "Eine vollständige Blockierung in diesem Fenster unterbricht die Gewohnheitsschleife.",
    reasonCompulsivityRepeat:
      "{name} wird in diesem Tagesabschnitt wiederholt entsperrt. Eine vollständige Blockierung zwischen {range} unterbricht die Gewohnheitsschleife.",
    reactivateHint: "Regel existiert, ist aber aus — tippen zum Reaktivieren",
  },
  permissionStatus: {
    granted: "Erteilt",
    denied: "Verweigert",
    unavailable: "Nicht verfügbar",
    notDetermined: "Nicht festgelegt",
  },
  onboarding: {
    progressLabel: "Onboarding-Fortschritt",
    continue: "Weiter",
    working: "Wird verarbeitet…",
    goToToday: "Zu Heute",
    narrative4Cta: "Wofür willst du diese Zeit?",
    narrative1ImageAlt: "Zero mit Bildschirm in der Hand, ohne es zu merken",
    narrative2ImageAlt: "Zero wird von Fäden zu einem leuchtenden Bildschirm gezogen",
    narrative3ImageAlt: "Zero am Tisch ohne Handy",
    narrative4ImageAlt: "Zero macht den ersten Schritt auf einem Weg ohne Handy",
    narrative1: [
      "Ist dir schon mal aufgefallen, wie du mit einem Bildschirm in der Hand dastehst, ohne es überhaupt zu merken? **15 Sekunden** Warten reichen und du greifst schon zum Bildschirm.",
      "Wir haben gelernt, **keine Leere** zu lassen und nicht einmal einen Augenblick innezuhalten.",
      "Ping, Scroll, Tab: man fühlt sich leicht verwirrt und **zersplittert**.",
    ],
    narrative2: [
      "Es ist kein Mangel an **Kraft und Willenskraft**. Apps sind konstruiert und entwickelt, um dich **da zu halten**: jedes Scrollen macht es schwerer, **loszulassen**.",
      "Screen0 hilft dir, **Abstand zu schaffen**, nicht danach zu streben, **perfekt** zu sein.",
    ],
    narrative3: [
      "Weniger Bildschirm bedeutet nicht weniger Leben, sondern mehr **Raum** für Arbeit, Menschen, Schlaf.",
      "Erlebe wieder eine Mahlzeit ohne Handy, einen Abend ohne Scrollen: die Grenzen wirken klein, aber sie machen einen **großen Unterschied**.",
    ],
    narrative4: [
      "**Du hast den ersten Schritt schon gemacht.**",
      "Ein Spaziergang ohne Handy. Ein Morgen ohne Feed. Veränderung **beginnt hier**.",
    ],
    benefitsHeadline: "So kann **Screen0** dir in der nächsten Woche helfen",
    benefits: [
      {
        title: "Fokus in Minuten",
        subtitle: "Einfache und anpassbare Einrichtung",
      },
      {
        title: "Gewinne über 2 Stunden täglich zurück",
        subtitle: "Weniger Scrollen. Mehr Zeit für das, was zählt.",
      },
      {
        title: "Erledige mehr",
        subtitle: "Bis zu 50 % produktiver bei der Arbeit mit Screen0",
      },
      {
        title: "Schlafe besser",
        subtitle:
          "Stoppe spätes Scrollen mit einem Schlafrhythmus, der wirklich funktioniert",
      },
    ],
    trialHeadline: "Premium **kostenlos.** testen. Keine Überraschungen.",
    trialRows: [
      {
        dayLabel: "TODAY",
        title: "Heute keine Gebühr",
        subtitle:
          "Nur Zugang zu Premium-Funktionen wie Regeln und Smart Blocks",
      },
      {
        dayLabel: "DAY 5",
        title: "Erinnerung vor Ende der Testphase",
        subtitle: "Wir erinnern dich 2 Tage vor Ende deiner kostenlosen Testphase",
      },
      {
        dayLabel: "DAY 7",
        title: "Jederzeit kündbar",
        subtitle: "Abonnements können jederzeit und ohne Angabe von Gründen gekündigt werden",
      },
    ],
    primaryGoalQuestion: "Wofür ist dir deine Zeit am wichtigsten?",
    timeLostQuestion: "Wo verlierst du am meisten Zeit?",
    timeLostSubtitle: "Du hast {goal} gewählt — wo geht die Zeit hin?",
    difficultyQuestion: "Wie schwer fällt es dir zu widerstehen?",
    goals: {
      work: "Arbeit",
      study: "Studium",
      sleep: "Schlaf",
      family: "Familie",
      hobby: "Hobby",
      exercise: "Bewegung",
      balance: "Balance",
      wellness: "Wohlbefinden",
      other: "Sonstiges",
    },
    timeLostOptions: {
      social: "Social Media",
      news: "Nachrichten",
      gaming: "Gaming",
      streaming: "Streaming",
      work: "Arbeit",
      shopping: "Shopping",
      messages: "Nachrichten",
      browsing: "Surfen",
      other: "Sonstiges",
    },
    difficultyEmojis: ["😌", "🙂", "😐", "😣", "😫"],
    difficultyLevels: [
      "Sehr leicht",
      "Leicht",
      "Manchmal schwer",
      "Schwer",
      "Sehr schwer",
    ],
    insight8ImageAlt: "Abendszene mit beiseitegelegtem Handy",
    insight8Headline: "**Das zählt.**",
    insight8Body:
      "Deine Zeit zu schützen ist eine der Grenzen, die wirklich wirken. Kleine Limits führen zu echter Veränderung.",
    insight8SleepHeadline: "**Das zählt.**",
    insight8SleepBody:
      "Nach 19 Uhr kann das Handy warten. **Abends abschalten** ist eine der Grenzen, die wirken.",
    insight9ImageAlt: "Illustration zu Aufmerksamkeit und Bildschirmen",
    insight9SocialHeadline: "Du bist gegen eine **Maschine**.",
    insight9SocialBody: "Der Feed hat kein Ende — er ist so **konstruiert**.",
    insight9OtherHeadline: "Jede Benachrichtigung **bricht** deinen Fokus.",
    insight9OtherBody: "Zurückzufinden kann **20 Minuten** dauern.",
    notificationsHeadline:
      "Wir senden dir **2 Tage** vor Ende der Testphase eine Erinnerung",
    notificationsBody:
      "Erlaube Benachrichtigungen, damit wir dich vor der Abbuchung erinnern können",
    notificationsAllow: "BENACHRICHTIGUNGEN ERLAUBEN",
    notificationsMaybeLater: "VIELLEICHT SPÄTER",
    notificationsDeniedWarning:
      "Benachrichtigungen sind aus. Aktiviere sie in den Einstellungen, damit wir dich vor Ende der Testphase erinnern können.",
    setupImageAlt: "Illustration Berechtigungen",
    setupTitle: "Eine kurze Berechtigung",
    setupBody:
      "Screen0 braucht Systemzugriff für deinen persönlichen Nutzungsbericht. Kein Konto erforderlich.",
    setupNativeHint: "Du kannst das jederzeit in den Einstellungen ändern.",
    setupWebHint:
      "Im Web brauchen Berichte die mobile App. Du kannst weitermachen und es später auf dem Handy einrichten.",
    vpnImageAlt: "Illustration des Website-Filters auf dem Gerät",
    vpnTitle: "Website-Filter installieren",
    vpnBody:
      "Um Websites in Safari und anderen mobilen Browsern zu blockieren, muss Screen0 ein lokales Filterprofil hinzufügen.",
    vpnBodyAndroid:
      "Um Websites in Chrome und anderen mobilen Browsern zu blockieren, muss Screen0 ein lokales Filterprofil hinzufügen.",
    vpnPrivacyTitle: "Verpflichtung zum Datenschutz",
    vpnPrivacyBody:
      "Das fügt einen Filter auf dem Gerät hinzu, der nur die von dir gewählten Websites blockiert. Das gesamte Filtern passiert auf deinem Handy — deine Daten verlassen das Gerät nie.",
    vpnWebHint:
      "Im Web braucht das Blockieren von Websites die mobile App. Du kannst weitermachen und es später auf dem Handy einrichten.",
    vpnInstall: "PROFIL INSTALLIEREN",
    vpnNotNow: "NICHT JETZT",
    vpnErrorTitle: "Filter konnte nicht installiert werden",
    vpnErrorHint: "Das VPN-Profil wurde nicht hinzugefügt. Du kannst es vorerst überspringen und später erneut versuchen.",
    trackingImageAlt: "Illustration anonymer Analysen",
    trackingTitle: "Unterstütze ein besseres Screen0",
    trackingBody:
      "Anonymes Tracking zu erlauben hilft uns zu verstehen, was funktioniert, und die App für alle zu verbessern.",
    trackingPrivacyTitle: "Verpflichtung zum Datenschutz",
    trackingPrivacyBody: "Keine Werbung, keine persönlichen Daten, kein Verkauf deiner Daten. Niemals.",
    trackingAllow: "WEITER",
    trackingNotNow: "NICHT JETZT",
    welcomeImageAlt: "Willkommens-Illustration",
    welcomeTitle: "Du bist bereit.",
    welcomeRecap:
      "Du willst mehr Zeit für **{goal}**. Screen0 hilft dir, sie zu schützen — ab heute.",
    welcomeRecapFallback:
      "Screen0 hilft dir, deine Zeit zu schützen — ab heute.",
    paywall: {
      headline: "Gewinne täglich 2+ Stunden mit Screen0 Premium",
      timeline: [
        {
          title: "Starte deine Fokus-Reise",
          description:
            "Du bist auf dem besten Weg, aus Vorsatz eine tägliche Fokus-Gewohnheit zu machen.",
        },
        {
          title: "Heute: Hol dir deinen Fokus zurück",
          description:
            "Schalte leistungsstarke Tools wie **Regeln** und **Smart Blocks** frei. Richte heute dein erstes Limit ein und schütze deine Zeit.",
        },
        {
          title: "Tag 5: Spüre den Unterschied",
          description:
            "Jetzt wirst du mehr Ruhe, Klarheit und Kontrolle über deine Zeit spüren. Wir erinnern dich vor Ende der Testphase — keine Überraschungen.",
        },
        {
          title: "Tag 7: Mach weiter",
          description:
            "Setze deine Fokus-Reise mit Premium fort. Kündige jederzeit, wenn es nicht passt.",
        },
      ],
      timelineTrialDescriptionWithTrial:
        "Starte deine {trialDays}-tägige kostenlose Testphase und schalte leistungsstarke Tools wie **Regeln** und **Smart Blocks** frei. Richte heute dein erstes Limit ein und schütze deine Zeit.",
      timelineTrialDescriptionNoTrial:
        "Schalte leistungsstarke Tools wie **Regeln** und **Smart Blocks** frei. Richte heute dein erstes Limit ein und schütze deine Zeit.",
      yearlyBadgeWithTrial: "{trialDays} Tage kostenlos testen, dann {price} /Jahr",
      yearlyBadgeNoTrial: "{price} /Jahr",
      yearlyTitle: "Jährlich",
      yearlySubtext: "(Nur {monthlyPrice} /Monat — weniger als ein Kaffee)",
      lifetimeTitle: "Lebenslang",
      lifetimeSubtext: "Einmaliger Kauf. Für immer deins.",
      ctaYearly: "KOSTENLOSE TESTPHASE STARTEN",
      ctaLifetime: "LEBENSLANGEN ZUGANG HOLEN",
      footerRenewal: "Verlängert sich automatisch bis zur Kündigung. Jederzeit kündbar.",
      footerLifetime: "Einmaliger Kauf. Kein Abonnement.",
      termsLink: "AGB",
      privacyLink: "Datenschutz",
      purchase: {
        processing: "Wird verarbeitet…",
        genericError: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        notEntitled: "Kauf abgeschlossen, aber Premium ist noch nicht aktiv. Bitte versuche es erneut.",
        webUnavailable: "Käufe sind nur in der Screen0-App verfügbar.",
        configError: "Käufe sind derzeit nicht verfügbar. Bitte versuche es später erneut.",
        offeringsError: "Preise konnten nicht geladen werden. Verbindung prüfen und erneut versuchen.",
        retry: "Erneut versuchen",
        restorePurchases: "Käufe wiederherstellen",
        restoreProcessing: "Wird wiederhergestellt…",
        restoreSuccess: "Käufe wiederhergestellt. Premium ist aktiv.",
        restoreNothingFound: "Keine Käufe zum Wiederherstellen gefunden.",
        restoreNothingFoundApple: "Keine Käufe für diese Apple-ID gefunden.",
        restoreNothingFoundGoogle: "Keine Käufe für dieses Google-Play-Konto gefunden.",
        restoreError: "Käufe konnten nicht wiederhergestellt werden. Bitte erneut versuchen.",
      },
    },
  },
  categories: {
    books: "Bücher",
    business: "Business",
    catalogs: "Kataloge",
    developerTools: "Entwickler-Tools",
    education: "Bildung",
    entertainment: "Unterhaltung",
    finance: "Finanzen",
    foodAndDrink: "Essen & Trinken",
    games: "Spiele",
    graphicsAndDesign: "Kreativität",
    healthAndFitness: "Gesundheit und Fitness",
    kids: "Kinder",
    lifestyle: "Lifestyle",
    medical: "Medizin",
    miscellaneous: "Sonstiges",
    music: "Musik",
    navigation: "Navigation",
    news: "Informationen und Lesen",
    newsstand: "Zeitschriften",
    photoAndVideo: "Foto & Video",
    productivity: "Produktivität und Finanzen",
    reference: "Nachschlagewerke",
    shopping: "Einkaufen und Essen",
    socialNetworking: "Soziales",
    sports: "Sport",
    stickers: "Sticker",
    travel: "Reisen",
    system: "System",
    utilities: "Dienstprogramme",
    weather: "Wetter",
    uncategorized: "Sonstiges",
    other: "Sonstiges",
    website: "Website",
  },
  websiteCategories: {
    modalTitle: "Website-Kategorien",
    expandInfoAria: "Details für {name} anzeigen",
    collapseInfoAria: "Details für {name} ausblenden",
    toggleCategoryAria: "{name} umschalten",
    domainsHeading: "Enthaltene Domains",
    removeCategoryAria: "{name} entfernen",
    browseCategoriesButton: "Kategorien",
    browseCategoriesAria: "Website-Kategorien öffnen",
    addWebsiteAria: "Website hinzufügen",
    social: {
      name: "Social",
      description: "Soziale Netzwerke, Foren und Community-Plattformen.",
    },
    meta: {
      name: "Meta",
      description: "Facebook, Instagram, WhatsApp und Messenger.",
    },
    messaging: {
      name: "Messaging",
      description: "Chat-Apps und Direktnachrichten-Dienste.",
    },
    news: {
      name: "Nachrichten",
      description: "Nachrichtenseiten, Verlage und Informationsportale.",
    },
    dating: {
      name: "Dating",
      description: "Dating-Apps und Partnerbörsen.",
    },
  },
});

export default GERMAN_TRANSLATIONS;
